import React, { useState } from "react";

const faqs = [
  { q:"What is microinsurance?", a:"Microinsurance is affordable insurance designed for low and middle income people. At Sajilo Policy, plans start at just Rs 99/week — making insurance accessible to every Nepali." },
  { q:"Who underwrites the policies?", a:"All our policies are underwritten by Himalayan Life Insurance, one of Nepal's most trusted and experienced insurance companies with over 20 years of service." },
  { q:"How do I buy a plan?", a:"Simply browse our plans, click Buy Now, fill in your basic details, and pay online via eSewa or Khalti. Your policy certificate is sent to your email instantly." },
  { q:"How do I make a claim?", a:"Call our helpline or email us with your policy number and incident details. Himalayan Life Insurance processes most claims within 3-7 working days." },
  { q:"Can I cancel my policy?", a:"Yes, you can cancel anytime. Refunds are processed based on the unused period of your policy." },
  { q:"Which payment methods are accepted?", a:"We accept eSewa, Khalti, ConnectIPS, and direct bank transfer." },
  { q:"Do I need any documents to buy?", a:"For most plans, just your name, phone number, email and date of birth is enough. No physical documents needed!" },
  { q:"Is my personal data safe?", a:"Absolutely. We use bank-level encryption to protect your data and never share it with third parties without your consent." },
];

function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" style={{padding:"80px 48px", background:"#f0fdfa"}}>
      <div style={{textAlign:"center", marginBottom:"56px"}}>
        <h2 style={{fontSize:"40px", fontWeight:"900", color:"#0f172a", marginBottom:"12px"}}>
          Frequently Asked <span style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent"}}>Questions</span>
        </h2>
        <p style={{fontSize:"16px", color:"#64748b"}}>Everything you need to know about Sajilo Policy</p>
      </div>
      <div style={{maxWidth:"720px", margin:"0 auto", display:"flex", flexDirection:"column", gap:"12px"}}>
        {faqs.map((faq, i) => (
          <div key={i}
            style={{background:"#fff", border: open === i ? "2px solid #0d9488" : "2px solid #e2e8f0", borderRadius:"16px", overflow:"hidden", transition:"all 0.3s"}}>
            <button onClick={() => setOpen(open === i ? null : i)}
              style={{width:"100%", background:"none", border:"none", padding:"20px 24px", display:"flex", justifyContent:"space-between", alignItems:"center", cursor:"pointer", color:"#0f172a", fontWeight:"700", fontSize:"15px", textAlign:"left"}}>
              {faq.q}
              <span style={{color:"#0d9488", fontSize:"20px", transition:"transform 0.3s", transform: open === i ? "rotate(45deg)" : "rotate(0)", flexShrink:0, marginLeft:"16px"}}>+</span>
            </button>
            {open === i && (
              <div style={{padding:"0 24px 20px", color:"#64748b", fontSize:"14px", lineHeight:"1.8"}}>
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;